import { useTranslation } from 'modules/domains/list';
import { LIST_COLUMNS } from '../../../types';

export const useColumn = (column: LIST_COLUMNS, sortable = true) => {
  const { t } = useTranslation();
  const label =
    column === LIST_COLUMNS.overflowMenu ? '' : t(`indexPage.table.columns.${column}.header`);
  return {
    id: column,
    label,
    isSortable: sortable,
  };
};
